import { MDBCol, MDBRow } from "mdb-react-ui-kit";
import useResumeProperties from "../../../hooks/useResumeProperties";

export default function CssfHeader() {

    const { logoSrc } = useResumeProperties();

    return (
        <header>
            <MDBRow className="cssf-header">
                <MDBCol md="3" className="header-cv">
                    <img
                        src={ logoSrc }
                        className="header-cv"
                        height="100"
                        alt=""
                        style={ {
                            marginTop: "20px",
                            marginLeft: "60px",
                        } }
                    />
                </MDBCol>
                <MDBCol md="9" className="text-start" style={ { display: "flex", alignItems: "flex-end" } }>
                    <div
                        className="content-div"
                        style={ {
                            fontFamily: "Verdana, sans-serif"
                        } }
                    >
                        <p className="h4" style={ { color: "#009999", margin: 0 } }>
                            <span className="fw-bold">
                                CURRICULUM VITAE
                            </span>
                        </p>
                    </div>
                </MDBCol>
            </MDBRow>
        </header>
    );
}
